import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  resetState: `${NAMESPACE}_RECOVER_PASSWORD_RESET_STATE`,
  recoverPasswordOnChange: `${NAMESPACE}_RECOVER_PASSWORD_ON_CHANGE`,
  requestChangePassword: `${NAMESPACE}_REQUEST_CHANGE_PASSWORD`,
  requestChangePasswordFailed: `${NAMESPACE}_REQUEST_CHANGE_PASSWORD_FAILED`,
  requestChangePasswordSuccess: `${NAMESPACE}_REQUEST_CHANGE_PASSWORD_SUCCESS`,
  fillMessage: `${NAMESPACE}_FILL_MESSAGE`
};

export const actionCreators = {
  resetState: () => ({ type: actions.resetState }),
  onChange: (payload) => ({ type: actions.recoverPasswordOnChange, payload }),
  requestChangePassword: (payload) => ({ type: actions.requestChangePassword, payload }),
  requestChangePasswordFailed: (payload) => ({ type: actions.requestChangePasswordFailed, payload }),
  requestChangePasswordSuccess: () => ({ type: actions.requestChangePasswordFailed }),
  fillMessage: (payload) => ({ type: actions.fillMessage, payload })
};

export default {
  actions,
  actionCreators
};
